import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Layout from "./layouts/Layout";
import Dashboard from "./pages/Dashboard/Dashboard";

import StateIndex from "./pages/Master/State/Index";
import CityIndex from "./pages/Master/City/Index";
import InsuranceMapIndex from "./pages/Master/InsuranceMap/Index";
import ZoneIndex from "./pages/Master/Zone/Index";

import UserIndex from "./pages/ManageUsers/User/Index";
import ActiveUserIndex from "./pages/ManageUsers/User/ActiveIndex";
import InactiveUserIndex from "./pages/ManageUsers/User/InactiveIndex";
import UserAdd from "./pages/ManageUsers/User/Add";

import UsertypeIndex from "./pages/ManageUsers/Usertype/Index";
import UserTypePermissionIndex from "./pages/ManageUsers/UserTypePermission/Index";
import UserPermissionIndex from "./pages/ManageUsers/UserPermission/Index";

import GeneralSettingAdd from "./pages/General Setting/Add";
import GeneralSettingAddSubmit from "./pages/General Setting/Add";

import Login from "./pages/auth/Login";
import Logout from "./pages/auth/Logout";
import { ToastContainer } from "react-toastify";

import GeofenceIndex from "./pages/Geofence/Index";
import GeofenceAdd from "./pages/Geofence/Add";

import HospitalIndex from "./pages/HospitalMaster/Hospital/Index";

import DesignationIndex from "./pages/Insurance/Designation/Index";
import EducationIndex from "./pages/Master/Education/Index";
import IncomeIndex from "./pages/Master/Income/Index";
import JobIndex from "./pages/Master/Job/Index";
import LocalityIndex from "./pages/Master/Locality/Index";
import OccupationIndex from "./pages/Master/Occupation/Index";
import RelationshipIndex from "./pages/Master/Relationship/Index";
import ChecklistIndex from "./pages/Master/Checklist/Index";
import SubChecklistIndex from "./pages/Master/SubChecklist/Index";
import TypeOfClaimIndex from "./pages/Insurance/TypeOfClaim/Index";
import InsuranceIndex from "./pages/Insurance/InsuranceCompany/Index";
import InsuranceTPAIndex from "./pages/Insurance/Tpa/Index";
import InsuranceManagerIndex from "./pages/Insurance/InsuranceManager/Index";
import AuthorityLetter from "./pages/Insurance/InsuranceCompany/AuthorityLetter";
import AuthorityLetterTPA from "./pages/Insurance/Tpa/AuthorityLetterTpa";
import RoomTypeIndex from "./pages/HospitalMaster/RoomType/Index";
import HospitalizationIndex from "./pages/HospitalMaster/HospitalizationType/Index";
import InjuryTypeIndex from "./pages/HospitalMaster/InjuryType/Index";


import CaseDetailsIndex from "./pages/CaseDetails/Index";
// import PendingDocumentIndex from "./pages/CaseDetails/PendingDocument";
import CaseSummaryIndex from "./pages/CaseDetails/CaseSummary";

import MapLiveTracking from "./pages/Map/LiveTrack";
import MapHistoryTracking from "./pages/Map/HistoryTrack";
import MonthlyAttendance from "./pages/attendance/MonthlyAttendance";
import DailyAttendance from "./pages/attendance/DailyAttendance";
import CallLogsIndex from "./pages/Field/CallLogs/Index";
import LeaveIndex from "./pages/attendance/LeaveIndex";
import MonthlyDetailsAttendance from "./pages/attendance/MonthlyDetailsAttendance";
import PendingDocument from "./pages/CaseDetails/PendingDocument";
import DynamicReport from "./pages/CaseDetails/DynamicReport";
import FeeStructure from "./Components/FormComponent/FeeStructure";
import UserWalletIndex from "./pages/attendance/UserWalletIndex";
import UserWalletDetail from "./pages/attendance/UserWalletDetail";
import TripReport from "./pages/attendance/TripReport";
import TripReportApproval from "./pages/attendance/TripReportApproval";
import AllLeaveRequest from "./pages/attendance/AllLeaveRequest";

const ACTIVE_CASE_ROUTES = [
  { path: "/Active-Case", case_url: "Case/All", title: "All Active Case" },
  { path: "/Initiated", case_url: "Initiated", title: "Case Initiated" },
  { path: "/On-Progress", case_url: "On-Progress", title: "On Progress Case" },
  { path: "/Assign-Field-Officer", case_url: "Assign-Field-Officer", title: "Assign Field Officer" },
  { path: "/Accepted-By-FO", case_url: "Accepted-By-FO", title: "Accepted By F.O." },
  { path: "/Rejected-By-FO", case_url: "Rejected-By-FO", title: "Rejected By F.O." },
  { path: "/Field-QC-Completed", case_url: "Field-QC-Pending", title: "Field Q.C. Pending" },
  { path: "/Waiting-for-Doctor-Allocation", case_url: "Waiting-for-Doctor-Allocation", title: "Waiting for Doctor Allocation" },
  { path: "/Doctor-Report-Pending", case_url: "Doctor-Report-Pending", title: "Doctor Report Pending" },
  { path: "/Manager-QC-Pending", case_url: "Manager-QC-Pending", title: "Manager QC Pending" },
  { path: "/Team-Leader-QC-Pending", case_url: "Team-Leader-QC-Pending", title: "Team Leader QC Pending" },
  { path: "/Waiting-For-Closer", case_url: "Waiting-For-Closer", title: "Waiting For Closer" },
  { path: "/Closed", case_url: "Closed", title: "Closed Case" },
];

const MY_CASE_ROUTES = [
  { path: "/My-Case-Initiated", case_url: "My-Case-Case/All", title: "All My Cases" },
  { path: "/My-Case-Initiated-Status", case_url: "My-Case-Initiated", title: "My Case Initiated" },
  { path: "/My-Case-On-Progress", case_url: "My-Case-On-Progress", title: "My Case On Progress" },
  { path: "/My-Case-Assign-Field-Officer", case_url: "My-Case-Assign-Field-Officer", title: "My Case Assign Field Officer" },
  { path: "/My-Case-Accepted-By-FO", case_url: "My-Case-Accepted-By-FO", title: "My Case Accepted By F.O." },
  { path: "/My-Case-Rejected-By-FO", case_url: "My-Case-Rejected-By-FO", title: "My Case Rejected By F.O." },
  { path: "/My-Case-Field-QC-Pending", case_url: "My-Case-Field-QC-Pending", title: "My Case Field Q.C. Pending" },
  { path: "/My-Case-Waiting-for-Doctor-Allocation", case_url: "My-Case-Waiting-for-Doctor-Allocation", title: "My Case Waiting for Doctor Allocation" },
  { path: "/My-Case-Doctor-Report-Pending", case_url: "My-Case-Doctor-Report-Pending", title: "My Case Doctor Report Pending" },
  { path: "/My-Case-Manager-QC-Pending", case_url: "My-Case-Manager-QC-Pending", title: "My Case Manager QC Pending" },
  { path: "/My-Case-Team-Leader-QC-Pending", case_url: "My-Case-Team-Leader-QC-Pending", title: "My Case Team Leader QC Pending" },
  { path: "/My-Case-Waiting-For-Closer", case_url: "My-Case-Waiting-For-Closer", title: "My Case Waiting For Closer" },
  { path: "/My-Case-Closed", case_url: "My-Case-Closed", title: "My Case Closed" },
];

const renderCaseDetailRoutes = (routes) =>
  routes.flatMap(({ path, case_url, title }) => [
    <Route
      key={path}
      path={path}
      element={<CaseDetailsIndex case_url={case_url} title={title} />}
    />,
    <Route
      key={`${path}-Motor`}
      path={`${path}-Motor`}
      element={<CaseDetailsIndex case_url={case_url} title={title} />}
    />,
  ]);

// Protect all routes which use main Layout
const PrivateRoute = () => {
  const {
    AuthReducer: { auth },
  } = useSelector((state) => state);

  const token = auth?.token;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return <Layout />;
};

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        {/* All authenticated routes go inside PrivateRoute */}
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Dashboard />} />

          <Route path="/Users" element={<UserIndex />} />
          <Route path="/Active-Users" element={<ActiveUserIndex />} />
          <Route path="/In-Active-Users" element={<InactiveUserIndex />} />
          <Route path="/Add-User" element={<UserAdd />} />
          <Route path="/Update-User/:id" element={<UserAdd />} />
          <Route path="/Fee-Structure/:id" element={<FeeStructure />} />

          <Route path="/State" element={<StateIndex />} />
          <Route path="/City" element={<CityIndex />} />
          <Route path="/Insurance-Mapping" element={<InsuranceMapIndex />} />
          <Route path="/Zone" element={<ZoneIndex />} />


          <Route path="/Usertype" element={<UsertypeIndex />} />
          <Route path="/User-Type-Permission" element={<UserTypePermissionIndex />} />
          <Route path="/User-Permission" element={<UserPermissionIndex />} />

          <Route path="/General-Settings" element={<GeneralSettingAdd />} />
          <Route path="/General-Settings" element={<GeneralSettingAddSubmit />} />

          <Route path="/Geofence" element={<GeofenceIndex />} />
          <Route path="/Add-Geofence" element={<GeofenceAdd />} />
          <Route path="/Update-Geofence/:id" element={<GeofenceAdd />} />

          <Route path="/Hospital" element={<HospitalIndex />} />
          <Route path="/Designation" element={<DesignationIndex />} />
          <Route path="/Income" element={<IncomeIndex />} />
          <Route path="/Education" element={<EducationIndex />} />
          <Route path="/Job" element={<JobIndex />} />
          <Route path="/Locality" element={<LocalityIndex />} />
          <Route path="/Occupation" element={<OccupationIndex />} />
          <Route path="/Relationship" element={<RelationshipIndex />} />
          <Route path="/Checklist" element={<ChecklistIndex />} />
          <Route path="/Sub-Checklist" element={<SubChecklistIndex />} />
          <Route path="/Type-Of-Claim" element={<TypeOfClaimIndex />} />
          <Route path="/Insurance-TPA" element={<InsuranceTPAIndex />} />
          <Route path="/Insurance-Company" element={<InsuranceIndex />} />
          <Route path="/Insurance-Manager" element={<InsuranceManagerIndex />} />
          <Route path="/Requirement-Letter/:id" element={<AuthorityLetter contentType="requirementLetter" />} />
          <Route path="/Authority-Letter/:id" element={<AuthorityLetter contentType="authorityLetter" />} />
          <Route path="/Report-Format/:id" element={<AuthorityLetter contentType="reportFormat" />} />
          <Route path="/Requirement-Letter-TPA/:id" element={<AuthorityLetterTPA contentType="requirementLetter" />} />
          <Route path="/Authority-Letter-TPA/:id" element={<AuthorityLetterTPA contentType="authorityLetter" />} />
          <Route path="/Report-Format-TPA/:id" element={<AuthorityLetterTPA contentType="reportFormat" />} />
          <Route path="/Dynamic-Report/:id" element={<DynamicReport />} />
          <Route path="/Room-Type" element={<RoomTypeIndex />} />
          <Route path="/Hospitalization-Type" element={<HospitalizationIndex />} />
          <Route path="/Injury-Type" element={<InjuryTypeIndex />} />

          {renderCaseDetailRoutes(ACTIVE_CASE_ROUTES)}
          {renderCaseDetailRoutes(MY_CASE_ROUTES)}

          <Route path="/Case-Summary/:id" element={<CaseSummaryIndex />} />
          <Route path="/Case-Summary-Motor/:id" element={<CaseSummaryIndex />} />
          <Route path="/Dynamic-Report-Motor/:id" element={<DynamicReport />} />
          <Route path="/Pending-Documents" element={<PendingDocument />} />

          <Route path="/Live-Tracking" element={<MapLiveTracking />} />
          <Route path="/History-Tracking" element={<MapHistoryTracking />} />


          <Route path="/Attendance/Daily" element={<DailyAttendance />} />
          <Route path="/Attendance/Monthly" element={<MonthlyAttendance />} />
          <Route path="/Attendance/Monthly-Details/:id/:month" element={<MonthlyDetailsAttendance />} />
          <Route path="/Attendance/Leave" element={<LeaveIndex />} />
          <Route path="/Attendance/All-Leave-Request" element={<AllLeaveRequest />} />
          <Route path="/User-Wallet" element={<UserWalletIndex />} />
          <Route path="/User-Wallet-Details/:userId" element={<UserWalletDetail />} />
          <Route path="/Field/Call-Log" element={<CallLogsIndex />} />
          <Route path="/Trip-Report" element={< TripReport />} />
          <Route path="/Trip-Report/:userID" element={< TripReport />} />
          <Route path="/Trip-Approval-Report" element={< TripReportApproval />} />

        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
